var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{key:_vm.renderKey,staticClass:"control-button",attrs:{"disabled":_vm.disabled || _vm.isLoading,"size":"lg","variant":_vm.colorVariant,"pill":""},on:{"click":_vm.handleClick}},[(!_vm.isLoading)?_vm._t("default"):_vm._e(),(_vm.isLoading)?_c('b-spinner',{staticClass:"align-middle",attrs:{"label":"Loading..."}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }